import * as Adapter from './adapters/localStorageAdapter'

const set = (key: string, value: string) => {
  return Adapter.set(key, value)
}

const remove = (key: string) => {
  return Adapter.remove(key)
}

const get = (key: string) => {
  return Adapter.get(key)
}

const clear = () => {
  return Adapter.clear()
}

const storageService = {
  set,
  remove,
  get,
  clear,
}

export default storageService
